<template>
<!-- Contact Section -->
<section class="contact-section">
  <div class="contact-container">

    <!-- Contact Information -->
    <div class="contact-info">
      <p class="section-subtitle">CONTACT US</p>
      <h2>Let's Talk</h2>
      <p class="intro-text">
        Whether you have a question about our products, your order, or
        anything else, our team is ready to help.
      </p>

      <div class="info-item">
        <div class="info-icon">✉️</div>
        <div>
          <h4>Email</h4>
          <p>timelessleather@gmail.com</p>
        </div>
      </div>

      <div class="info-item">
        <div class="info-icon">☎️</div>
        <div>
          <h4>Phone</h4>
          <p>+234 803 394 8393</p>
        </div>
      </div>

      <div class="info-item">
        <div class="info-icon">⌖</div>
        <div>
          <h4>Location</h4>
          <p>Ikorodu, Lagos State</p>
        </div>
      </div>
    </div>

    <!-- Contact Form -->
    <div class="contact-form">
      <p class="section-subtitle">SEND A MESSAGE</p>
      <h2>How Can We Help?</h2>

      <form @submit.prevent="submitForm">

        <div class="form-row">

          <div class="form-group">
            <label>Name</label>
            <input
              type="text"
              v-model="form.name"
              placeholder="Your name"
              required
            >
          </div>

          <div class="form-group">
            <label>Email</label>
            <input
              type="email"
              v-model="form.email"
              placeholder="Your email"
              required
            >
          </div>

        </div>

        <div class="form-group">
          <label>Subject</label>
          <input
            type="text"
            v-model="form.subject"
            placeholder="What is this about?"
            required
          >
        </div>

        <div class="form-group">
          <label>Message</label>
          <textarea
            rows="6"
            v-model="form.message"
            placeholder="Write your message here..."
            required
          ></textarea>
        </div>

        <button type="submit">
          Send Message
        </button>

        <!-- Success Message -->
        <div v-if="successMessage" class="success-message">
          {{ successMessage }}
        </div>

      </form>
    </div>

  </div>
</section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        subject: "",
        message: ""
      },

      successMessage: ""
    };
  },

  methods: {
    submitForm() {
      if (
        !this.form.name ||
        !this.form.email ||
        !this.form.subject ||
        !this.form.message
      ) {
        return;
      }

      this.successMessage =
        "Thank you! Your message has been sent successfully.";

      this.form = {
        name: "",
        email: "",
        subject: "",
        message: ""
      };
    }
  }
};
</script>

<style scoped>
.contact-section {
  padding: 90px 20px;
  background-color: #f8f5f1;
}

.contact-container {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 70px;
}

.section-subtitle {
  color: #b85c45;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2px;
  margin-bottom: 10px;
}

.contact-info h2,
.contact-form h2 {
  color: #292929;
  font-size: 34px;
  margin-bottom: 18px;
}

.intro-text {
  color: #666;
  line-height: 1.7;
  margin-bottom: 35px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 25px;
}

.info-icon {
  width: 45px;
  height: 45px;
  background-color: #b85c45;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.info-item h4 {
  color: #292929;
  margin: 0 0 5px;
  font-size: 16px;
}

.info-item p {
  color: #666;
  margin: 0;
}

.contact-form {
  background-color: #ffffff;
  padding: 40px;
  border-radius: 8px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: #292929;
  font-weight: 600;
  margin-bottom: 8px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 13px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #b85c45;
}

.form-group textarea {
  resize: vertical;
}

.contact-form button {
  background-color: #b85c45;
  color: #ffffff;
  border: none;
  padding: 14px 28px;
  border-radius: 4px;
  font-size: 15px;
  cursor: pointer;
  transition: 0.3s ease;
}

.contact-form button:hover {
  background-color: #292929;
}

@media (max-width: 768px) {
  .contact-section {
    padding: 60px 20px;
  }

  .contact-container {
    grid-template-columns: 1fr;
    gap: 45px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .contact-form {
    padding: 30px 20px;
  }
}

.success-message {
  margin-top: 20px;
  padding: 15px;
  background-color: #f1e4df;
  color: #292929;
  border-left: 4px solid #b85c45;
  border-radius: 4px;
}
</style>